<template>
  <div id="app">
    <div id= 'notice' v-if ='alert || refreshAlert'><ul>
      STAGING

    </ul></div>
    <loading-page></loading-page>
    <router-view></router-view>
    <app-footer/>
  </div>
</template>

<script>
import LoadingPage from '@/components/LoadingPage'
import AppFooter from '@/components/AppFooter/AppFooter'
import Vue from 'vue'
export default {
  name: 'app',
  data: () => ({
    refreshAlert:false
  }),
  computed: {
    alert: {
      get() {
        if(this.$store.getters['Alert/alert'] != null){
          this.refreshAlert = null
        }
        return this.$store.getters['Alert/alert']
      },
      set(value) {
        // Use a Vuex mutation to update the alert state
        this.$store.commit('Alert/SET_ALERT', value)
      }
    }
  },
   methods: {
async checkDevServer() {
        try {
          let data = await axios.get('https://devapp.liverunapp.com/')
          return true
        } catch (err) {
          return false
        }
      },
   },
  components: {
    LoadingPage,AppFooter
  },
  async created(){
      if(this.$envStatus == 'Staging'){
        this.refreshAlert = false
        // Use store dispatch instead of direct assignment
        this.$store.commit('Alert/SET_ALERT', null)
        Vue.prototype.$isStage = 0
        Vue.prototype.$fbDbEntry = 'racers'
      }else{
        // Use store dispatch instead of direct assignment
        this.$store.commit('Alert/SET_ALERT', null)
        this.refreshAlert = true
        Vue.prototype.$isStage = 1
        Vue.prototype.$fbDbEntry = 'racers-test'
          if (await this.checkDevServer()) {
            Vue.http.options.root = 'https://devapp.liverunapp.com/api'
          } else {
            Vue.http.options.root = 'https://liverunapi.npit.xyz/api'
          }
       // Vue.http.options.root = 'https://devapp.liverunapp.com/api'
      }
  }

}
</script>
<style>
#notice ul {
  background-color: #ff5e00;
    color: white;
    font-family: monospace;
    font-size: 15px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// App.vue?e63f17a4